(function() {
  /* Several sections can include this file on one page — only run once. */
  if (window.__pseCollectionJsLoaded) return;
  window.__pseCollectionJsLoaded = true;
 
  var isMobile = function() { return window.innerWidth < 750; };
 
  /* Small on-screen message. Errors always show it; open any page with
     ?pse_debug=1 at the end of the URL to also see what the "+" is doing. */
  var PSE_DEBUG = /[?&]pse_debug=1/.test(window.location.search);
  function pseToast(msg, ms) {
    try {
      var t = document.getElementById('pse-toast');
      if (!t) {
        t = document.createElement('div');
        t.id = 'pse-toast';
        t.style.cssText = 'position:fixed;left:12px;right:12px;bottom:16px;z-index:2147483647;' +
          'background:#111;color:#fff;font:13px/1.4 Arial,sans-serif;padding:12px 14px;' +
          'border-radius:10px;border:1px solid #ff0111;';
        document.body.appendChild(t);
      }
      t.textContent = msg;
      t.style.display = 'block';
      clearTimeout(t.__hide);
      t.__hide = setTimeout(function() { t.style.display = 'none'; }, ms || 4000);
    } catch (e) {}
  }
 
  /* ═══════════════════════════════════════════════
     PRODUCT IMAGE (static — first image only, no swipe)
     ─────────────────────────────────────────────
     The per-image swipe/drag-to-change-image interaction
     used to live here, but its left/right arrows and dots
     are hidden in this section's CSS, so that gesture was
     only ever invisible to users — while still capturing
     touch/mouse drags meant for the outer product carousel.
     That's what caused "the image scrolls instead of the
     product card". Removed the drag logic entirely; clicking
     a card still navigates to the product page below.
  ═══════════════════════════════════════════════ */
 
  /* ── Click on a card navigates to its product page ── */
  function initImgDrag(wrap) {
    wrap.addEventListener('click', function(e) {
      /* If click was on interactive elements inside wrap, ignore */
      if (
        e.target.closest('.pse-img-arrow') ||
        e.target.closest('.pse-img-dot') ||
        e.target.closest('.pse-plus-btn') ||
        e.target.closest('.pse-size-inline')
      ) {
        return;
      }
 
      var card = wrap.closest('.pse-card');
      if (card && card.dataset.productUrl) {
        window.location.href = card.dataset.productUrl;
      }
    });
  }
 
  /* ─── SECTION-LEVEL DESKTOP ARROW SCROLL ─── */
  var pseScroll = function(sid, dir) {
    var track = document.getElementById('pse-track-' + sid);
    if (!track) return;
    var card = track.querySelector('.pse-card');
    if (!card) return;
    var cardW = card.offsetWidth + 8;
    track.scrollBy({ left: dir * cardW * 2, behavior: 'smooth' });
    setTimeout(function() { pseUpdateArrows(sid); }, 350);
  };
 
  function pseUpdateArrows(sid) {
    var track = document.getElementById('pse-track-' + sid);
    var prev  = document.getElementById('pse-prev-' + sid);
    var next  = document.getElementById('pse-next-' + sid);
    if (!track || !prev || !next) return;
    prev.classList.toggle('hidden', track.scrollLeft < 10);
    next.classList.toggle('hidden', track.scrollLeft + track.clientWidth >= track.scrollWidth - 10);
  }
 
  /* ─── SECTION-LEVEL MOBILE SLIDER DOTS ─── */
  function initMobileDots(sid) {
    var track    = document.getElementById('pse-track-' + sid);
    var dotsWrap = document.getElementById('pse-dots-' + sid);
    if (!track || !dotsWrap) return;
    if (!track.classList.contains('pse-track--mob-slider')) return;
 
    var cards = track.querySelectorAll('.pse-card');
    dotsWrap.innerHTML = '';
    cards.forEach(function(_, i) {
      var dot = document.createElement('button');
      dot.className = 'pse-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function() {
        var cardW = cards[0].offsetWidth + 12;
        track.scrollTo({ left: i * cardW, behavior: 'smooth' });
      });
      dotsWrap.appendChild(dot);
    });
 
    track.addEventListener('scroll', function() {
      var dots = dotsWrap.querySelectorAll('.pse-dot');
      var idx  = Math.round(track.scrollLeft / (cards[0].offsetWidth + 12));
      dots.forEach(function(d, i) { d.classList.toggle('active', i === idx); });
    });
  }
 
  /* ─── Wire up a freshly-populated track (used for both initial load
         and after recommendations are injected) ─── */
  function initTrack(track) {
    var sid = track.id.replace('pse-track-', '');
 
    track.querySelectorAll('.pse-card__img-wrap').forEach(function(wrap) {
      initImgDrag(wrap);
    });
 
    if (track.classList.contains('pse-track--slider')) {
      track.addEventListener('scroll', function() { pseUpdateArrows(sid); });
      pseUpdateArrows(sid);
    }
    if (isMobile()) initMobileDots(sid);
  }
 
  /* ═══════════════════════════════════════════════
     AUTOMATIC PRODUCT RECOMMENDATIONS
     Fetches this same section rendered through Shopify's
     recommendations endpoint, then swaps the resulting
     product cards into the (currently empty) track.
     Shopify's engine already excludes the viewed product
     and never returns duplicates.
  ═══════════════════════════════════════════════ */
  function loadRecommendations(sectionEl) {
    var url = sectionEl.dataset.pseRecoUrl;
    if (!url) return;
 
    fetch(url)
      .then(function(res) {
        if (!res.ok) throw new Error('Recommendations request failed');
        return res.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc    = parser.parseFromString(html, 'text/html');
        var newTrack = doc.querySelector('.pse-track');
        var ownTrack = sectionEl.querySelector('.pse-track');
        if (!newTrack || !ownTrack) return;
 
        /* Extra safety dedupe on top of Shopify's own de-duping,
           in case of any overlap between multiple sections/sources */
        var seen = {};
        Array.prototype.slice.call(newTrack.querySelectorAll('.pse-card')).forEach(function(card) {
          var pid = card.dataset.productId;
          if (pid && seen[pid]) {
            card.remove();
          } else if (pid) {
            seen[pid] = true;
          }
        });
 
        if (!newTrack.querySelector('.pse-card')) {
          /* No recommendations available — hide the section rather
             than showing an empty block */
          sectionEl.style.display = 'none';
          return;
        }
 
        ownTrack.innerHTML = newTrack.innerHTML;
        initTrack(ownTrack);
      })
      .catch(function(err) {
        console.error('[PSE Recommendations]', err.message);
        sectionEl.style.display = 'none';
      });
  }
 
  /* ─── DOM READY ─── */
  function pseInitAll() {
    document.querySelectorAll('.pse-track').forEach(function(track) {
      initTrack(track);
    });
 
    document.querySelectorAll('[data-pse-reco="true"]').forEach(function(sectionEl) {
      loadRecommendations(sectionEl);
    });
  }
 
  /* ─── Price line (sale price + optional struck compare-at price) ─── */
  function pseSetPrice(el, price, compare, save) {
    if (!el) return;
    el.textContent = '';
    var row = document.createElement('span');
    row.className = 'pse-sheet__price-row';
    var main = document.createElement('span');
    main.textContent = price || '';
    row.appendChild(main);
    if (save && parseInt(save) > 0) {
      var tag = document.createElement('span');
      tag.className = 'pse-sheet__save';
      tag.textContent = 'Save ' + parseInt(save) + '%';
      row.appendChild(tag);
    }
    el.appendChild(row);
    if (compare) {
      var old = document.createElement('s');
      old.className = 'pse-sheet__compare';
      old.textContent = compare;
      el.appendChild(old);
    }
  }
 
  /* ─── BUILD SIZE BUTTONS ─── */
  function buildSizes(card, container, onSelectCallback) {
    container.innerHTML = '';
    var variantsData = JSON.parse(card.dataset.variants || '[]');
    var optionsData  = JSON.parse(card.dataset.options  || '[]');
    var sizeOptIdx   = 0;
    optionsData.forEach(function(opt, i) { if (/size/i.test(opt.name)) sizeOptIdx = i; });
 
    var seen = {};
    variantsData.forEach(function(v) {
      var sizeVal = v.options[sizeOptIdx];
      if (seen[sizeVal]) return;
      seen[sizeVal] = true;
      var btn = document.createElement('button');
      btn.className = 'pse-size-btn' + (v.available ? '' : ' unavail');
      btn.textContent = sizeVal;
      btn.dataset.variantId = v.id;
      btn.dataset.price     = v.price;
      btn.dataset.compare   = v.compare_at_price || '';
      btn.dataset.save      = v.save || 0;
      btn.disabled = !v.available;
      if (onSelectCallback) {
        btn.addEventListener('click', function() {
          if (btn.classList.contains('unavail')) return;
          onSelectCallback(btn);
        });
      }
      container.appendChild(btn);
    });
  }
 
  /* ─── DESKTOP INLINE PICKER ─── */
  var pseOpenPicker = function(plusBtn) {
    if (isMobile()) { pseOpenSheet(plusBtn); return; }
 
    var card    = plusBtn.closest('.pse-card');
    var pid     = card.dataset.productId;
    var panel   = document.getElementById('pse-inline-' + pid);
    var sizesEl = document.getElementById('pse-sizes-' + pid);
    if (!panel || !sizesEl) return;
 
    document.querySelectorAll('.pse-size-inline.open').forEach(function(p) {
      if (p !== panel) {
        p.classList.remove('open');
        var op = p.closest('.pse-card').querySelector('.pse-plus-btn');
        if (op) op.classList.remove('active');
      }
    });
 
    var isOpen = panel.classList.contains('open');
    panel.classList.toggle('open', !isOpen);
    plusBtn.classList.toggle('active', !isOpen);
 
    if (!isOpen) {
      buildSizes(card, sizesEl, function(sizeBtn) {
        /* Auto-add to cart on size click */
        var variantId = parseInt(sizeBtn.dataset.variantId);
        sizeBtn.classList.add('adding');
        var proxyBtn = { textContent: '', disabled: false };
        pseAddToCart(variantId, proxyBtn, function() {
          panel.classList.remove('open');
          plusBtn.classList.remove('active');
        });
      });
    }
  };
 
  var pseClosePicker = function(pid) {
    var panel   = document.getElementById('pse-inline-' + pid);
    var card    = panel && panel.closest('.pse-card');
    var plusBtn = card && card.querySelector('.pse-plus-btn');
    if (panel)   panel.classList.remove('open');
    if (plusBtn) plusBtn.classList.remove('active');
  };
 
  /* ═══════════════════════════════════════════════
     MOBILE BOTTOM SHEET
     ─────────────────────────────────────────────
     Made sturdier so the "+" works on every page / section:
       • ONE shared sheet lives directly under <body>, so no parent
         section (transform, overflow, z-index, …) can hide or clip it.
       • If a page has no sheet markup at all, it is built on the fly.
       • The colours / glass settings of the section the card belongs to
         are copied onto the sheet each time it opens.
  ═══════════════════════════════════════════════ */
  var _sheetCard = null;
 
  var SHEET_VARS = [
    '--pse-sheet-bg', '--pse-sheet-border', '--pse-sheet-radius', '--pse-sheet-dim',
    '--pse-glass-tint', '--pse-glass-opacity', '--pse-glass-blur',
    '--pse-badge-bg', '--pse-badge-color', '--pse-close-color',
    '--pse-popup-title-color', '--pse-popup-price-color', '--pse-select-size-label-color',
    '--pse-atc-bg', '--pse-atc-color',
    '--pse-size-bg', '--pse-size-color', '--pse-size-border',
    '--pse-size-selected-bg', '--pse-size-selected-color',
    '--pse-size-soldout-tint', '--pse-size-soldout-opacity', '--pse-size-soldout-blur',
    '--pse-size-soldout-text', '--pse-size-soldout-strike',
    '--pse-compare-color'
  ];
 
  function buildSheetMarkup(badgeText) {
    var badge = badgeText ? '<span class="pse-sheet__badge"></span>' : '';
    var wrap = document.createElement('div');
    wrap.className = 'pse-sheet-overlay';
    wrap.id = 'pse-sheet-overlay';
    wrap.innerHTML =
      '<div class="pse-sheet" id="pse-sheet">' +
        '<div class="pse-sheet__head">' +
          '<div><p class="pse-sheet__title" id="pse-sheet-title"></p>' + badge + '</div>' +
          '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px">' +
            '<button class="pse-sheet__close" type="button">&#x2715;</button>' +
            '<p class="pse-sheet__price" id="pse-sheet-price"></p>' +
          '</div>' +
        '</div>' +
        '<p class="pse-sheet__size-label">Select Size</p>' +
        '<div class="pse-sheet__sizes" id="pse-sheet-sizes"></div>' +
        '<button class="pse-sheet-atc" id="pse-sheet-atc" type="button">Select a size</button>' +
      '</div>';
    if (badgeText) wrap.querySelector('.pse-sheet__badge').textContent = badgeText;
    return wrap;
  }
 
  function getSheetOverlay() {
    var list = Array.prototype.slice.call(document.querySelectorAll('.pse-sheet-overlay'));
    var overlay = null;
 
    /* prefer the one already under <body>, otherwise take the first */
    list.forEach(function(o) { if (!overlay && o.parentNode === document.body) overlay = o; });
    if (!overlay) overlay = list[0] || null;
 
    if (!overlay) {
      var badgeEl = document.querySelector('.pse-badge:not(.pse-badge--soldout)');
      overlay = buildSheetMarkup(badgeEl ? badgeEl.textContent.trim() : '');
    }
 
    /* one shared sheet: drop duplicates left by other sections */
    list.forEach(function(o) { if (o !== overlay && o.parentNode) o.parentNode.removeChild(o); });
 
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
 
    /* wire it up once (also covers a sheet that was built by JS) */
    if (!overlay.__pseWired) {
      overlay.__pseWired = true;
      overlay.removeAttribute('onclick');
      overlay.addEventListener('click', function(e) { pseCloseSheet(e); });
 
      var closeBtn = overlay.querySelector('.pse-sheet__close');
      if (closeBtn) {
        closeBtn.removeAttribute('onclick');
        closeBtn.addEventListener('click', function() { pseCloseSheet(); });
      }
      var atcBtn = overlay.querySelector('#pse-sheet-atc');
      if (atcBtn) {
        atcBtn.removeAttribute('onclick');
        atcBtn.addEventListener('click', function() { pseSheetAtc(); });
      }
    }
    return overlay;
  }
 
  function copySheetVars(overlay, card) {
    var cs = window.getComputedStyle(card);
    SHEET_VARS.forEach(function(name) {
      var val = cs.getPropertyValue(name).trim();
      if (val) overlay.style.setProperty(name, val);
    });
  }
 
  var pseOpenSheet = function(plusBtn) {
    try {
      _sheetCard = plusBtn.closest('.pse-card');
      if (!_sheetCard) return;
 
      var overlay = getSheetOverlay();
      copySheetVars(overlay, _sheetCard);
 
      var titleEl = overlay.querySelector('#pse-sheet-title');
      var priceEl = overlay.querySelector('#pse-sheet-price');
      var sizesEl = overlay.querySelector('#pse-sheet-sizes');
      var atcBtn  = overlay.querySelector('#pse-sheet-atc');
 
      titleEl.textContent = _sheetCard.dataset.productTitle;
      pseSetPrice(priceEl, _sheetCard.dataset.productPrice, _sheetCard.dataset.productCompare || '');
      atcBtn.textContent  = 'Select a size';
      atcBtn.disabled     = true;
 
      /* Pass select callback to buildSizes so .selected class is added */
      buildSizes(_sheetCard, sizesEl, function(sizeBtn) {
        /* Remove selected from all siblings */
        sizesEl.querySelectorAll('.pse-size-btn').forEach(function(b) {
          b.classList.remove('selected');
        });
        /* Mark this one selected */
        sizeBtn.classList.add('selected');
        /* Enable ATC button and update price (+ compare-at price) */
        atcBtn.disabled = false;
        atcBtn.textContent = 'ADD TO CART';
        pseSetPrice(priceEl, sizeBtn.dataset.price, sizeBtn.dataset.compare, sizeBtn.dataset.save);
      });
 
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
 
      var sizeCount = sizesEl.querySelectorAll('.pse-size-btn').length;
      if (!sizeCount) pseToast('No sizes found for this product (check the product options / a "Size" option).', 6000);
 
      if (PSE_DEBUG) {
        setTimeout(function() {
          var sheetEl = overlay.querySelector('.pse-sheet');
          var r = sheetEl ? sheetEl.getBoundingClientRect() : { top: 0, height: 0 };
          pseToast('popup opened · sizes ' + sizeCount + ' · popup top ' + Math.round(r.top) +
                   ' · height ' + Math.round(r.height) + ' · window height ' + window.innerHeight +
                   ' · under <body>: ' + (overlay.parentNode === document.body), 6000);
        }, 450);
      }
    } catch (err) {
      console.error('[PSE Sheet]', err);
      pseToast('Size popup error: ' + (err && err.message ? err.message : err), 7000);
    }
  };
 
  var pseCloseSheet = function(e) {
    var overlay = document.getElementById('pse-sheet-overlay');
    if (!overlay) return;
    if (e && e.target !== overlay) return;
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    _sheetCard = null;
  };
 
  var pseSheetAtc = function() {
    if (!_sheetCard) return;
    var overlay = document.getElementById('pse-sheet-overlay');
    if (!overlay) return;
    var sizesEl = overlay.querySelector('#pse-sheet-sizes');
    var selBtn  = sizesEl.querySelector('.pse-size-btn.selected');
    if (!selBtn) return;
    var atcBtn = overlay.querySelector('#pse-sheet-atc');
    pseAddToCart(parseInt(selBtn.dataset.variantId), atcBtn, function() {
      setTimeout(function() {
        overlay.classList.remove('open');
        document.body.style.overflow = '';
        _sheetCard = null;
      }, 800);
    });
  };
 
  /* ═══════════════════════════════════════════════
     "+" BUTTON — one global listener for every section.
     Runs first (capture phase on window), so the theme's own click
     handlers can't interfere, and it works for cards added later
     (filters, recommendations) without any re-wiring.
  ═══════════════════════════════════════════════ */
  window.addEventListener('click', function(e) {
    var btn = e.target && e.target.closest ? e.target.closest('.pse-plus-btn') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (PSE_DEBUG) {
      pseToast('"+" tapped · script loaded · screen width ' + window.innerWidth +
               ' · ' + (isMobile() ? 'mobile popup' : 'desktop picker'), 2500);
    }
    try {
      pseOpenPicker(btn);
    } catch (err) {
      console.error('[PSE +]', err);
      pseToast('Quick add error: ' + (err && err.message ? err.message : err), 7000);
    }
  }, true);
 
  /* ─── ADD TO CART ─── */
  var pseAddToCart = function(variantId, btn, onSuccess) {
    if (!variantId) return;
 
    var originalText = btn.textContent.trim();
    btn.textContent  = 'Adding...';
    btn.disabled     = true;
 
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(res) {
      if (!res.ok) return res.json().then(function(e) { throw new Error(e.description || 'Add failed'); });
      return res.json();
    })
    .then(function() {
      return fetch(window.Shopify.routes.root + 'cart.js', {
        headers: { 'Accept': 'application/json' }
      }).then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      var cartSummary = {
        id:            cart.token,
        totalQuantity: cart.item_count,
        cost: {
          totalAmount: {
            amount:       (parseFloat(cart.total_price) / 100).toFixed(2),
            currencyCode: cart.currency
          }
        },
        lines: (cart.items || []).map(function(item) {
          return {
            id:       String(item.key || item.id),
            quantity: item.quantity,
            cost: {
              totalAmount: {
                amount:       (parseFloat(item.final_line_price) / 100).toFixed(2),
                currencyCode: cart.currency
              }
            }
          };
        })
      };
 
      var resolveUpdate;
      var updatePromise = new Promise(function(resolve) { resolveUpdate = resolve; });
 
      var linesUpdateEvent = new CustomEvent('shopify:cart:lines-update', {
        bubbles: true, cancelable: true,
        detail:  { action: 'add', context: 'standard-action' }
      });
      linesUpdateEvent.promise = updatePromise;
      linesUpdateEvent.action  = 'add';
 
      document.dispatchEvent(linesUpdateEvent);
      resolveUpdate({ cart: cartSummary, detail: { itemCount: cart.item_count } });
 
      document.querySelectorAll('cart-icon').forEach(function(el) {
        if (typeof el.renderCartBubble === 'function') {
          el.renderCartBubble(cart.item_count);
        }
      });
 
      setTimeout(function() {
        var drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('open')) {
          drawer.open();
        }
      }, 120);
 
      btn.textContent = 'Added!';
      setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 1600);
      if (onSuccess) onSuccess();
    })
    .catch(function(err) {
      console.error('[PSE Cart]', err.message);
      btn.textContent = 'Error — Retry';
      setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 2200);
    });
  };
 
  /* Public names used by inline onclick="" attributes in the section markup.
     The code above always calls its own local copies, so it keeps working even
     if an older copy of this script overwrites these later. */
  window.pseScroll       = pseScroll;
  window.pseOpenPicker   = pseOpenPicker;
  window.pseClosePicker  = pseClosePicker;
  window.pseOpenSheet    = pseOpenSheet;
  window.pseCloseSheet   = pseCloseSheet;
  window.pseSheetAtc     = pseSheetAtc;
  window.pseAddToCart    = pseAddToCart;
 
  /* Start-up work (arrows, dots, recommendations) runs LAST and inside try/catch,
     so even if something here fails, the "+" above is already fully set up. */
  function pseSafeInit() {
    try { pseInitAll(); } catch (err) { console.error('[PSE init]', err); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pseSafeInit);
  } else {
    pseSafeInit();
  }
 
})();